function Plasterboard() {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Back sheet */}
      <rect x="22" y="10" width="28" height="40" rx="2" />
      {/* Front sheet overlapping */}
      <rect x="14" y="18" width="28" height="40" rx="2" fill="#16171a" />
      {/* Texture lines */}
      <line x1="20" y1="28" x2="36" y2="44" />
      <line x1="14" y1="40" x2="24" y2="50" />
    </svg>
  );
}

export default Plasterboard;
